import { render, staticRenderFns } from "./SamLabel.vue?vue&type=template&id=05704cf5&scoped=true&"
import script from "./SamLabel.vue?vue&type=script&lang=js&"
export * from "./SamLabel.vue?vue&type=script&lang=js&"
import style0 from "./SamLabel.vue?vue&type=style&index=0&id=05704cf5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05704cf5",
  null
  
)

export default component.exports